import { render, staticRenderFns } from "./SignConsentModal.vue?vue&type=template&id=62306522"
import script from "./SignConsentModal.vue?vue&type=script&lang=js"
export * from "./SignConsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports